import { Link, createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { useState, type FormEvent } from 'react';
import { post } from '../lib/api';
import { useAuth } from '../lib/auth';
import { Campo } from '../ui/campos';

export const Route = createFileRoute('/login')({
  beforeLoad: ({ context }) => {
    if (context.auth.setupNecessario) throw redirect({ to: '/setup' });
    if (context.auth.eu) throw redirect({ to: '/' });
  },
  component: Login,
});

function Login() {
  const auth = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [codigo, setCodigo] = useState('');
  const [desafio, setDesafio] = useState<string | null>(null);
  const [esqueci, setEsqueci] = useState<'nao' | 'form' | 'enviado'>('nao');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      if (esqueci === 'form') { await post('/v1/auth/esqueci', { email }); setEsqueci('enviado'); return; }
      if (desafio) { await auth.validar2fa(desafio, codigo); await nav({ to: '/' }); return; }
      const r = await auth.entrar(email, senha);
      if (r) { setDesafio(r.desafio); return; }
      await nav({ to: '/' });
    } catch (err) {
      setErro(err instanceof Error ? err.message : 'não foi possível entrar');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="entrada">
      <div className="cartao">
        <div className="marca">
          <span className="logo-mark">SGC</span>
          <div><h1>{desafio ? 'Segundo fator' : esqueci !== 'nao' ? 'Recuperar senha' : 'Entrar'}</h1><div className="sub">gestão de tarefas e obrigações do escritório</div></div>
        </div>
        <form onSubmit={enviar}>
          {erro && <div className="alerta erro">{erro}</div>}
          {esqueci === 'enviado' ? (
            <>
              <div className="alerta ok">Se esse e-mail estiver cadastrado, o link para escolher uma nova senha chega em instantes (vale por 1 hora).</div>
              <button className="btn" type="button" onClick={() => { setEsqueci('nao'); setErro(null); }}>Voltar</button>
            </>
          ) : esqueci === 'form' ? (
            <>
              <Campo rotulo="E-mail" valor={email} onChange={setEmail} type="email" autoComplete="username" autoFocus required />
              <button className="btn primario" type="submit" disabled={enviando}>{enviando ? 'enviando…' : 'Enviar link'}</button>
              <button className="btn link" type="button" onClick={() => setEsqueci('nao')}>voltar</button>
            </>
          ) : desafio ? (
            <>
              <div className="mini">Abra o aplicativo autenticador e digite o código de 6 dígitos — ou um dos códigos de recuperação.</div>
              <Campo rotulo="Código" valor={codigo} onChange={setCodigo} inputMode="numeric" autoComplete="one-time-code" autoFocus required placeholder="000000" />
              <button className="btn primario" type="submit" disabled={enviando}>{enviando ? 'conferindo…' : 'Confirmar'}</button>
              <button className="btn link" type="button" onClick={() => { setDesafio(null); setCodigo(''); setErro(null); }}>voltar</button>
            </>
          ) : (
            <>
              <Campo rotulo="E-mail" valor={email} onChange={setEmail} type="email" autoComplete="username" autoFocus required />
              <Campo rotulo="Senha" valor={senha} onChange={setSenha} type="password" autoComplete="current-password" required />
              <button className="btn primario" type="submit" disabled={enviando}>{enviando ? 'entrando…' : 'Entrar'}</button>
              <button className="btn link" type="button" onClick={() => { setEsqueci('form'); setErro(null); }}>esqueci minha senha</button>
            </>
          )}
        </form>
        <Link to="/" style={{ display: 'none' }}>início</Link>
      </div>
    </div>
  );
}
